
import App from './App.vue'
import Vue from 'vue'
// import Raven from 'raven-js';
// import RavenVue from 'raven-js/plugins/vue';

if(!IS_DEV){
    let Raven = require('raven-js');
    let RavenVue = require('raven-js/plugins/vue');
    Raven.config('https://8957835380e347269cec3c5936b41b36@sentry.io/265369').addPlugin(RavenVue, Vue).install();
}

new Vue({
    el: '#root',
    render: h => h(App)
    ,methods:{
        drag(map){
            this.$children[0].drag(map);
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/main.js
// module id = 16
// module chunks = 0